import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';

const Dummy_Banner = [
  // {
  //   img: '/assets/images/banner/Mo_MainAnchorBanner.png',
  //   url: '1',
  //   backgroundColor: '#042EA4',
  //   link: '/promotion/땅집고옥션-오픈기념-이벤트',
  // },
  {
    img: '/assets/images/banner/MainBanner3.png',
    url: '3',
    backgroundColor: '#98C6FF',
    link: '/promotion/땅집고옥션-얼리버드-이벤트',
    name: '얼리버드',
  },
  {
    img: '/assets/images/banner/MainBanner4.png',
    url: '4',
    backgroundColor: '#F7FEFF',
    link: '/promotion/5일-무료체험-이벤트',
    name: '무료체험',
  },
  {
    img: '/assets/images/banner/MainBanner5.png',
    url: '5',
    backgroundColor: '#0B0B0C',
    link: '/quant',
    name: '퀀트',
  },
  {
    img: '/assets/images/banner/MainBanner2.png',
    url: '2',
    backgroundColor: '#4078ff',
    link: '/myAlgorithm',
    name: '알고리즘',
  },
];

const Banner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const navigate = useNavigate();

  const { modalDispatch } = useModal();

  // const now = new Date();
  // const utc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  // const koreaTimeDiff = 9 * 60 * 60 * 1000;
  // const koreaTime = new Date(utc + koreaTimeDiff);

  // const hideDate = new Date('2025-06-10T00:00:00+09:00');

  // const filteredBanner = Dummy_Banner.filter((item, idx) => {
  //   // 첫 번째 배너는 6/10 00시 이후면 제외
  //   if (idx === 0 && koreaTime >= hideDate) return false;
  //   return true;
  // });

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      nextBanner();
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused, currentIndex]);

  const handlePause = (e: any) => {
    e.stopPropagation();
    setIsPaused(!isPaused);
  };

  const nextBanner = (e?: any) => {
    if (e) {
      e.stopPropagation();
    }
    setCurrentIndex((prevIndex) => (prevIndex + 1) % Dummy_Banner.length);
  };

  const prevBanner = (e: any) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? Dummy_Banner.length - 1 : prevIndex - 1,
    );
  };

  const handleClick = () => {
    if (
      !isLogin() &&
      ['알고리즘', '퀀트'].includes(Dummy_Banner[currentIndex].name)
    ) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      // showAlert('로그인 후 이용해주세요.', navigate);
      return;
    }
    navigate(Dummy_Banner[currentIndex].link);
  };

  return (
    <SlideBanner onClick={handleClick}>
      <Inner bg={Dummy_Banner[currentIndex].backgroundColor}>
        <InnerContent>
          <img src={Dummy_Banner[currentIndex].img} alt="" />
        </InnerContent>
        <ButtonBox>
          {/* 연결되는 페이지 없는 관계로 일단 숨김처리 
            자세히 보기
            <DetailButton style={{ visibility: 'hidden' }}>
          </DetailButton> */}
          <ControlButtonBox>
            <StopButton>
              <img
                onClick={handlePause}
                src="/assets/images/icon/banner_stop.png"
                alt=""
              />
            </StopButton>
            <ListCountButton>
              <div>{currentIndex + 1}</div>
              <div>/</div>
              <div>{Dummy_Banner.length}</div>
            </ListCountButton>
            <BannerMoveBox>
              <MoveButton>
                <img
                  onClick={prevBanner}
                  src="/assets/images/arrow/24_white_left_Arrow.png"
                  alt=""
                />
              </MoveButton>
              <MoveButton>
                <img
                  onClick={nextBanner}
                  src="/assets/images/arrow/24_white_right_Arrow.png"
                  alt=""
                />
              </MoveButton>
            </BannerMoveBox>
          </ControlButtonBox>
        </ButtonBox>
      </Inner>
    </SlideBanner>
  );
};

export default Banner;

const SlideBanner = styled.div`
  width: 100%;
  height: 170px;
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div<{ bg: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: ${(props) => props.bg};
  position: relative;
`;

const InnerContent = styled.div`
  width: 328px;
  height: 138px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-content: right;
  align-items: center;
  position: absolute;
  padding-right: 8px;
  bottom: 0px;
`;

const ControlButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: 30px;
`;

const StopButton = styled.div`
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
`;

const MoveButton = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 10px;
  img {
    cursor: pointer;
    width: 17px;
    height: 17px;
  }
`;

const DetailButton = styled.span`
  width: 98px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #222222;
  color: white;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  border-radius: 9999px;
`;

const BannerMoveBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 25px;
  background-color: rgba(0, 0, 0, 0.21);
  border-radius: 9999px;
`;
const ListCountButton = styled.div`
  height: 25px;
  width: 41px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  gap: 3px;
  background: rgba(0, 0, 0, 0.21);
  font-size: 12px;
  color: white;
  font-family: Spoqa Han Sans Neo;
  line-height: 23.2px;
  word-wrap: break-word;
`;
